import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";
import { mapExchangeMaster } from "@/redux/mappers/MasterMapper/MasterMapper";


export const productGeneralApi = createApi({
  reducerPath: "productGeneralApi",
  baseQuery,
  tagTypes: ["productGeneral","exchangeMaster"],
  endpoints: (builder) => ({

    getAllGeneral: builder.query({
      query: ({ id }) => `export/product/general/${id}`,
      transformResponse: (response) => response?.data ?? [],
      providesTags: ["productGeneral"],
    }),

    //Create Product General

    createProductGeneral: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/export/product/general/${id}`,
        method: "PUT",
        headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
        body: { productGeneral: data },
      }),
      invalidatesTags: ["productGeneral"],
    }),

    //Updated Product General

    updateProductGeneral: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/export/product/general/${id}`,
        method: "PUT",
        headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
        body: { productGeneral: data },
      }),
      invalidatesTags: ["productGeneral"],
    }),
    getExchangeMasterId : builder.query({
      query: ({id}) => `/master/exchangeRate/product/${id}`,
      transformResponse: (response) => {
        return response?.data?.map(mapExchangeMaster);
      },
      providesTags: ["exchangeMaster"],
    })

  })
});
export const {
  useGetDistrictMasterQuery,  
  useLazyGetAllGeneralQuery,
  useCreateProductGeneralMutation,
  useUpdateProductGeneralMutation,
  useGetExchangeMasterIdQuery

} = productGeneralApi;



